module.exports = __webpack_public_path__ + "img/mi-compliment-geven.eb32a42a.svg";